import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02e94f54")

_pushScopeId("data-v-02e94f54")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("自动化任务")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("执行历史")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_5 = {
  key: 0,
  style: {"color":"mediumseagreen"}
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"goldenrod"}
}
const _hoisted_7 = {
  key: 2,
  style: {"color":"blue"}
}
const _hoisted_8 = {
  key: 3,
  style: {"color":"#cc0000"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
                default: _withId(() => [
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider),
              _withDirectives(_createVNode(_component_el_card, { class: "tableMinH spacName" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "spacForm"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "任务名称" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.name_search,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name_search = $event)),
                            placeholder: "任务名称"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "状态" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.status_search,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.status_search = $event)),
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.status_options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "执行者" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.user_search,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user_search = $event)),
                            placeholder: "执行者"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearch('Search')))
                          }, {
                            default: _withId(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "info",
                            onClick: _ctx.onClear
                          }, {
                            default: _withId(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table, {
                    size: "small",
                    data: _ctx.get_data.results,
                    "header-cell-class-name": "tabelHeader",
                    onRowClick: _ctx.handleDetail
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "id",
                        label: "任务执行id"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.id), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "task_name",
                        label: "任务名称"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.task_name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "readable_status",
                        label: "状态"
                      }, {
                        default: _withId((scope) => [
                          _createVNode(_component_el_space, null, {
                            default: _withId(() => [
                              (scope.row.readable_status === '完成')
                                ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(scope.row.readable_status), 1))
                                : _createCommentVNode("", true),
                              (scope.row.readable_status === '暂停')
                                ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(scope.row.readable_status), 1))
                                : _createCommentVNode("", true),
                              (scope.row.readable_status === '进行中')
                                ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(scope.row.readable_status), 1))
                                : _createCommentVNode("", true),
                              (
                      scope.row.readable_status === '取消' ||
                      scope.row.readable_status === '异常'
                    )
                                ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(scope.row.readable_status), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskFields, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: item.label,
                          index: index,
                          label: item.label,
                          prop: item.prop
                        }, null, 8, ["index", "label", "prop"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["data", "onRowClick"])
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.loading]
              ]),
              _createVNode(_component_el_footer, { class: "footerStyle" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        style: {"margin-bottom":"0"},
                        label: "每页"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.record,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.record = $event)),
                            style: {"width":"50px"},
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearch('paging')))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        style: {"margin-bottom":"0"},
                        label: "条记录"
                      }),
                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                        default: _withId(() => [
                          _createVNode(_component_el_pagination, {
                            onCurrentChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch('paging'))),
                            currentPage: _ctx.currentPage1,
                            "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentPage1 = $event)),
                            "page-size": _ctx.record,
                            layout: "total, prev, pager, next, jumper",
                            total: _ctx.get_data.count
                          }, null, 8, ["currentPage", "page-size", "total"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})